export const EMOJI_FONT_FAMILY = "Noto Color Emoji";

export const FONT_FALLBACKS = [
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Times",
    "Symbola",
    "Aegyptus",
    "Code2000",
    "Code2001",
    "Code2002",
    "Musica",
    "serif",
    "LastResort",
] as const;

export const FONT_SIZE_MULTIPLIER = 0.8;

export const CENTER_Y_OFFSET = 0.8;
